import * as Yup from 'yup';

export interface OrbitPrivacyConsentValues {
    acceptTerms: boolean;
}

export const initialValues: OrbitPrivacyConsentValues = {
    acceptTerms: false,
};

export const validationSchema = Yup.object({
    acceptTerms: Yup.boolean()
        .oneOf([true], 'Debes aceptar el tratamiento de datos personales')
        .required('Debes aceptar el tratamiento de datos personales'),
});
